module.exports = __webpack_public_path__ + "img/spex.c4f1fa28.png";